// Canonical list of Bohol municipalities (47 municipalities + 1 city = 48)
// Used across the app for dropdowns, address parsing, and stats.
export const municipalities = [
  'Alburquerque',
  'Alicia',
  'Anda',
  'Antequera',
  'Baclayon',
  'Balilihan',
  'Batuan',
  'Bien Unido',
  'Bilar',
  'Buenavista',
  'Calape',
  'Candijay',
  'Carmen',
  'Catigbian',
  'Clarin',
  'Corella',
  'Cortes',
  'Dagohoy',
  'Danao',
  'Dauis',
  'Dimiao',
  'Duero',
  'Garcia Hernandez',
  'Getafe',
  'Guindulman',
  'Inabanga',
  'Jagna',
  'Lila',
  'Loay',
  'Loboc',
  'Loon',
  'Mabini',
  'Maribojoc',
  'Panglao',
  'Pilar',
  'Pres. Carlos P. Garcia',
  'Sagbayan',
  'San Isidro',
  'San Miguel',
  'Sevilla',
  'Sierra Bullones',
  'Sikatuna',
  'Tagbilaran City',
  'Talibon',
  'Trinidad',
  'Tubigon',
  'Ubay',
  'Valencia',
];
